module.exports = "data:image/gif;base64,R0lGODlhGwASAJEAAP////+9Y/+cAP///yH/C05FVFNDQVBFMi4wAwEAAAAh+QQJKAADACwAAAEAGwARAAACQJSPqcvtDxU4U4A7q6WyeqSF0vaB5DZmBvapmmmVnLuIKHwnNsut0Q8MCh+D4iFQTCqXzKQB2YxGBVCpVVm9SgsAIfkECSgAAwAsAAAAABsAEQAAAkCUj6nL7Q8VOFOAO6ulsnqkhdL2geQ2Zgb2qZpplZy7iCh8JzbLrdEPDAofg+IhUEwql8ykAdmMRgVQqVVZvUoLADs="


//////////////////
// WEBPACK FOOTER
// ./static/img/new.gif
// module id = iM9b
// module chunks = 2